import { render, staticRenderFns } from "./CoupangBanner.vue?vue&type=template&id=3a5a5594"
import script from "./CoupangBanner.vue?vue&type=script&lang=js"
export * from "./CoupangBanner.vue?vue&type=script&lang=js"
import style0 from "./CoupangBanner.vue?vue&type=style&index=0&id=3a5a5594&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports